import { bankAdminViews, bankUserViews } from "../../data";

/**
 *
 * @param {string} view view to be authorized
 * @param {Array} extraAllowedViews extra allowed views granted
 * @param {Array} blockedViews blocked views
 * @param {string} userType user type ['bank-admin', 'bank-user']
 * @returns
 */
const canView = (view, allowedViews, blockedViews, userType) => {
  if (blockedViews.includes(view)) return false;

  let allAllowedViews = [];
  if (userType === "bank-user")
    allAllowedViews = [...Object.values(bankUserViews), ...allowedViews];
  else if (userType === "bank-admin")
    allAllowedViews = [...Object.values(bankAdminViews), ...allowedViews];

  if (allAllowedViews.includes(view)) return true;
  else return false;
};
export default canView;
